export default __webpack_public_path__ + "static/media/image12.cb4160c6.jpg";